// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__WOQHP","info":"Pagination_info__DV1N9","list":"Pagination_list__eSQi6"};